import { useConfig } from "@/context/ConfigContext";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";
import OwnerForm from "@/components/forms/OwnerForm";
import TenantForm from "@/components/forms/TenantForm";

export default function FormSection({ kind }) {
  const { t } = useLang();
  const config = useConfig();
  const title = kind === "owner" ? t.form.ownerTitle : t.form.tenantTitle;

  return (
    <section id="form" className="bg-mist py-20 md:py-28 border-t border-line scroll-mt-20" data-testid="form-section">
      <div className="mx-auto max-w-2xl px-4 md:px-8">
        <Reveal className="text-center">
          <div className="flex justify-center"><Overline>{t.form.overline}</Overline></div>
          <h2 className="mt-4 font-serif font-semibold text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.08]">
            {title}
          </h2>
        </Reveal>
        <Reveal delay={0.08} className="mt-10">
          <div className="bg-paper border border-line rounded-3xl p-6 md:p-9 shadow-sm">
            {kind === "owner" ? <OwnerForm config={config} /> : <TenantForm config={config} />}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
